//natives
import React, { useState } from "react";
import Moment from "moment";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import TagManager from "react-gtm-module";
import { Typography, Tooltip, List, ListItem, Link } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import Avatar from "@material-ui/core/Avatar";
import CardHeader from "@material-ui/core/CardHeader";
import Icon from "@material-ui/core/Icon";

import { ContactsModal } from "./ContactsModal/index";

//css
import GrupoCss from "./Grupo-css";

const useStyles = GrupoCss();

function Contatos(props) {
  const classes = useStyles();

  const capitalized = (value) => {
    return value[0].toUpperCase() + value.substr(1);
  };

  const checkRoute = (value) => {
    if (value["dir"].includes(";@Assets")) {
      props.pai.props.pai.props.router.push(
        `${value["route"]}s/arquivos/${value["id"]}`
      );
    } else {
      window.open(value["dir"], "_blank");
    }

    TagManager.dataLayer({
      dataLayer: {
        event: "event",
        eventCategory: "tokstok:fornecedores:inicio",
        eventAction: "clique:contatos",
        eventLabel: `arquivo-${value["id"]}`,
      },
    });
  };

  return (
    <List dense={true} className={classes.root}>
      {props.itens.map((item, index) => (
        <div
          key={index}
          hidden={
            (new Date() > new Date(item.lancamento) &&
              new Date() < new Date(item.termino)) ||
            (item.lancamento == null && item.lancamento == null) ||
            props.permissao !== 1
              ? false
              : true
          }
        >
          {item.diretorio ? (
            <ListItem
              alignItems={"flex-start"}
              disablegutters={"true"}
              key={index}
              button
              className={classes.item}
              onClick={() => {
                checkRoute({
                  id: item.id,
                  dir: item.diretorio,
                  route: "contato",
                });
              }}
            >
              <Typography
                component="span"
                variant="body1"
                className={classes.inline}
                color="textPrimary"
                style={
                  props.pai.state.listaNovo.includes(item.id)
                    ? { fontWeight: "bold" }
                    : null
                }
              >
                {item.titulo
                  ? capitalized(item.titulo)
                  : capitalized(item.descricao)}
              </Typography>
            </ListItem>
          ) : (
            <Typography
              component="span"
              variant="body1"
              className={classes.inline}
              color="textPrimary"
              style={
                props.pai.state.listaNovo.includes(item.id)
                  ? { fontWeight: "bold" }
                  : null
              }
            >
              {item.titulo
                ? capitalized(item.titulo)
                : capitalized(item.descricao)}
            </Typography>
          )}

          {props.permissao === 1 && (
            <div>
              {new Date(item.lancamento) > new Date() && (
                <Tooltip
                  title={
                    "Lançamento marcado para dia " +
                    Moment(item.lancamento).format("d MMM YYYY")
                  }
                >
                  <CalendarTodayIcon className={classes.icons} />
                </Tooltip>
              )}
            </div>
          )}
        </div>
      ))}
    </List>
  );
}

export default function (props) {
  const classes = useStyles();
  const [openModal, setOpenModal] = useState(false);
  function goToContactUsPage() {
    props.props.router.push("/contact");
  }

  return (
      <><ContactsModal
      isOpen={openModal}
      handleClose={() => setOpenModal(false)} /><Card>
        <CardHeader
          className={classes.card}
          title={<div>
            <Typography className={classes.root} variant="caption">
              <Link className={classes.linkTitle} onClick={() => setOpenModal(true)}>Ver contatos</Link>
            </Typography>
            <br />
            <Typography className={classes.root} variant="caption">
              <Link className={classes.linkTitle} onClick={() => goToContactUsPage()}>Fale conosco</Link>
            </Typography>
          </div>}
          avatar={<Avatar aria-label="recipe" className={classes.avatar}>
            <Icon>call</Icon>
          </Avatar>} />
      </Card></>
  );
}